import { Control, FieldValues, UseFormSetValue } from "react-hook-form";

import {
  IFormAttributes,
  IProductionRecurringTime,
  TTimeHHmm,
} from "@ryde/shared";

export interface ITimeListItemForm {
  fieldName: string;
  control?: Control;
  index?: number;
  onEdit?: () => void;
  onCancelOuter?: () => void;
  value?: Partial<IProductionRecurringTime>;
  setValueOuter?: UseFormSetValue<FieldValues>;
  removeHandler?: (index: number) => void;
  formAttributes?: IFormAttributes | null;
  disabledEdit?: boolean;
  disabledRemove?: boolean;
}

export const emptyTimeItem: IProductionRecurringTime = {
  time: "" as TTimeHHmm,
};

export const timeItemFormFieldNames: (keyof IProductionRecurringTime)[] = [
  "time",
];

export const timeItemSerialized = (item: IProductionRecurringTime): string => {
  return `${item?.time || ""}`;
};
